import { ReactElement } from "react"

import DownloadButton from "./downloadButton"
import { Datasets } from "../../constants/enums"
import useAttachmentDownload from "../../services/middleware/hooks/deviceRegisters/useAttachmentDownload"

interface IDownloadDeviceAttachmentButtonProps {
    deviceSysRef: string
    fileName: string
    dataset: Datasets
    attachmentUuid?: string
    isAmendment?: boolean
}

/**
 * Button which allows user to download large attachments.
 * @example
 * <DownloadTTRAttachmentButton deviceRef={deviceRef} fileName={fileName} />
 */
const DownloadDeviceAttachmentButton = ({
    deviceSysRef,
    fileName,
    dataset,
    attachmentUuid,
    isAmendment,
}: IDownloadDeviceAttachmentButtonProps): ReactElement => {
    const { downloadAttachment } = useAttachmentDownload()
    const urlFetcher: () => Promise<void> = () =>
        downloadAttachment(
            deviceSysRef,
            fileName,
            dataset,
            attachmentUuid,
            isAmendment
        )
    return <DownloadButton urlOrFetcher={urlFetcher} sensitiveDataWarning />
}

DownloadDeviceAttachmentButton.defaultProps = {
    attachmentUuid: undefined,
    isAmendment: false,
}

export default DownloadDeviceAttachmentButton
